import { ReactNode } from 'react';

import { PointItem } from 'components/point-item';
import Button from 'components/ui/button';

interface AcoesEngajamentoProps {
  itens: any[];
  cicloLabel?: string;
  /** Cartões sazonais (Retrospectiva, Páscoa, Carnaval, Álbum), com as condições da página. */
  sazonais?: ReactNode;
}

export default function AcoesEngajamento({ itens, cicloLabel, sazonais }: AcoesEngajamentoProps) {
  return (
    <div className="flex flex-col gap-3">
      {itens.map(item => (
        <PointItem key={item._id} data={item} cycleLabel={cicloLabel} />
      ))}
      {sazonais}
    </div>
  );
}

interface CartaoSazonalProps {
  etiqueta: string;
  titulo: string;
  tom: 'lilas' | 'verde';
  rotuloDoBotao: string;
  onAbrir: () => void;
  /** O modal do cartão, quando ele vive junto do botão. */
  children?: ReactNode;
}

const FUNDO: Record<CartaoSazonalProps['tom'], string> = {
  lilas: 'bg-brand-purple-light',
  verde: 'bg-brand-green-light',
};

export function CartaoSazonal({ etiqueta, titulo, tom, rotuloDoBotao, onAbrir, children }: CartaoSazonalProps) {
  return (
    <section
      aria-label={etiqueta}
      className={`${FUNDO[tom]} flex flex-wrap items-center gap-5 rounded-2xl px-5 py-[22px] transition first-of-type:mt-2.5 hover:-translate-y-0.5 hover:shadow-[0_8px_20px_rgba(0,45,75,0.12)] lg:px-[30px]`}
    >
      <div className="min-w-0 flex-1">
        <span className="mb-[7px] inline-block rounded-jj-pill bg-white/[0.72] px-[13px] py-[5px] font-display text-[11px] font-bold uppercase tracking-[0.05em] text-brand-blue-dark">
          {etiqueta}
        </span>
        <p className="m-0 font-display text-base font-bold text-content">{titulo}</p>
      </div>
      <Button variant="principal" onClick={onAbrir}>
        {rotuloDoBotao}
      </Button>
      {children}
    </section>
  );
}
